import { api, api_max } from '../../../services'

export const setToken = (token) => {
  api.defaults.headers.Authorization = `Bearer ${token}`
  api_max.defaults.headers.Authorization = `Bearer ${token}`
}
